export default "__VITE_ASSET__BWM9cVCH__"